// Lib Imports
// import { createContext } from 'react';

// export default createContext();

import EventEmitter from 'granite-admin/utils/event-emitter';
let grandEmitter = null;
function loadGrandEmitter() {
  grandEmitter = new EventEmitter();
}
function getGrandEmitter() {
  return grandEmitter;
}
export { loadGrandEmitter, getGrandEmitter };